import { memo } from 'react';
import  type { PropsWithChildren, ComponentProps } from 'react';
import IconButton from '../IconButton';
import CloseIcon from '../icons/CloseIcon';
import { type CallbackFunc } from '@/types/types';
import styles from './Drawer.module.css';

export interface DrawerProps extends PropsWithChildren, ComponentProps<'div'> {
    width: number;
    open: boolean;
    onClose?: CallbackFunc;
}

interface DrawerCloseBoxProps extends ComponentProps<"div"> {
    onClose?: CallbackFunc;
}

function DrawerCloseBox(props: DrawerCloseBoxProps) {
    const onClose = () => {
        if (props.onClose) {
            props.onClose();
        }
    };

    return (
        <div className={styles.closeBoxContainer}>
            <IconButton className={styles.closeButton} onClick={onClose}>
                <CloseIcon size={{width: 24, height: 24}} fill="#7D7D7D" />
            </IconButton>
        </div>
    )
}

function _drawer(props: DrawerProps) {
    const drawerStyles = {
        width: `${props.width}px`
    }
    const drawerClasses: string[] = [styles.drawer];

    const onClose = () => {
        if (props.onClose) {
            props.onClose();
        }
    }

    if (props.open) {
        drawerClasses.push(styles.open)
    }

    return (
        <div className={drawerClasses.join(' ')} style={drawerStyles} >
            { props.onClose && <DrawerCloseBox onClick={onClose} /> }
            <div className={styles.drawer__inner}>
                {props.children}
            </div>
        </div>
    )
}

const Drawer = memo(_drawer);
export default Drawer;